import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { AdminRequestDetail } from "./types";

// GET /api/admin/mdf/requests/:id → AdminRequestDetail
//
// Sub-bucket 15 — drawer/detail load. Pulls the request row + fund + partner
// + reviewer (if any) + signed download URLs for supporting_doc_url (legacy
// single-doc field) and every bucket-9 mdf_attachments row. The drawer
// renders the receipts the partner uploaded; admin doesn't upload receipts
// of its own (per legacy parity).
export function useMdfRequest(id: string | null | undefined) {
  return useQuery<AdminRequestDetail, ApiClientError>({
    queryKey: queryKeys.mdf.request(id ?? ""),
    queryFn: () => apiFetch<AdminRequestDetail>(`/admin/mdf/requests/${id}`),
    enabled: !!id,
  });
}
